exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".currency-wrapper[data-v-7a78b517]{display:flex;color:#000}.currency-label[data-v-7a78b517]{margin-right:5px}.currency-symble[data-v-7a78b517]{margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a78b517","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/footer/CurrencyField.vue
// module id = 493
// module chunks = 187